import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { Column, Typography, useOverlayContext } from 'seagull';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const useDeleteLegalTerms = (param)=>{
    let { onSuccess, confirmActionTestId } = param;
    const { api } = useStoreActions();
    const { t: texts } = useLocaleKeys('components.legalTermsDropdown');
    const queryClient = useQueryClient();
    const { showConfirmAction } = useOverlayContext();
    const { mutateAsync: deleteLegalTerms, isPending } = useMutationState({
        mutationFn: async (legalTermsId)=>{
            await api.business.removeLegalTerms(legalTermsId);
            return legalTermsId;
        },
        onSuccess: async ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.LegalTerms
                ]
            });
        }
    });
    const onDeleteLegalTerm = (data)=>{
        showConfirmAction({
            testId: confirmActionTestId,
            skin: 'danger',
            title: texts.deleteDocumentTitle(),
            content: /*#__PURE__*/ _jsxs(Column, {
                gap: 22,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: texts.deleteDocumentContent({
                            documentName: data.name
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: texts.existingUnaffected()
                    })
                ]
            }),
            primaryButtonLabel: texts.deleteButton(),
            secondaryButtonLabel: texts.cancelButton(),
            onConfirm: async ()=>{
                await deleteLegalTerms(data.id);
                await onSuccess(data.id);
            }
        });
    };
    return {
        deleteLegalTerms: onDeleteLegalTerm,
        isPending
    };
};
